import React, {Component} from 'react';
import LoanableValuesView from "./LoanableValuesView";
import {Button} from "primereact/button";

const dataValoresPrest = [
    {
        folio: 1,
        tipo: "BONOS",
        cantidad: "1000",
        plazo: "14",
        tasa: "0.2",
        sobretasa: "0",
        precioMin: "106.720000",
    },
    {
        folio: 1,
        tipo: "cetes",
        cantidad: "2000",
        plazo: "28",
        tasa: "0.4",
        sobretasa: "0",
        precioMin: "106.720000",
    },
    {
        folio: 1,
        tipo: "UDIBONOS",
        cantidad: "1100",
        plazo: "7",
        tasa: "0.68",
        sobretasa: "0",
        precioMin: "106.720000",
    },
];


function getDataLoanableValues() {
    return dataValoresPrest;
}

export default class LoanableValuesContainer extends Component {

    constructor() {
        super();
        this.state = {
            grupos: [],
        };
    }

    componentDidMount() {
        this.setState({
            dataLoanableValues: getDataLoanableValues(),
        })
    }

    render() {
        let headerLoanableValues =
            <div style={{textAlign: 'right'}}>
                <Button type="button" iconPos="left" label="Postura Rápida" style={{marginRight: '.5em'}}/>
                <Button icon="pi pi-refresh" style={{'float': 'right'}}/>
            </div>;
        const {dataLoanableValues} = this.state;
        return (
            <LoanableValuesView dataLoanableValues={dataLoanableValues}
                                headerLoanableValues={headerLoanableValues}
            />
        );
    }
}
